import { SEARCHED_DETAILS, SELECT_JUMP_SEAT, VERIFY_INTERNATIONAL_DOCUMENT, PRINTER_POPUP_SEARCH_PAGE, INITIAL_BAGGAGE_COUNT } from './SearchType'
import { BAG_ADDED, SELECT_LRT_BAGTYPE } from '../Bags/BagType'

const initialStateSearch={
    SearchedRecordData :[],
    SearchedFlightDetails:{},
    isBagAdded: 0,
    isJumpSeatSelected: false,
    isInternationalDocumentVerified: false,
    lrtBagTypeForPassenger: {},
    isPrinterPopupSearchPageOpen: true,
    initialBaggageCount: []
}

const searchReducer=(state=initialStateSearch,action)=>
{
    switch(action.type)
    {
        case SEARCHED_DETAILS: return{
            ...state,
            SearchedRecordData:action.SearchedRecordData,
            SearchedFlightDetails:action.SearchedFlightDetails
        }
        case BAG_ADDED: return{
            ...state,
            isBagAdded: action.isBagAdded
        }
        case SELECT_JUMP_SEAT: return{
            ...state,
            isJumpSeatSelected: action.isJumpSeatSelected
        }
        case VERIFY_INTERNATIONAL_DOCUMENT: return{
            ...state,
            isInternationalDocumentVerified: action.isInternationalDocumentVerified
        }
        case SELECT_LRT_BAGTYPE: return {
            ...state,
            lrtBagTypeForPassenger: action.lrtBagTypeForPassenger
        }
        case PRINTER_POPUP_SEARCH_PAGE: return{
            ...state,
            isPrinterPopupSearchPageOpen: action.isPrinterPopupSearchPageOpen
        }
        case INITIAL_BAGGAGE_COUNT: return {
            ...state,
            initialBaggageCount: action.initialBaggageCount
        }
        default: return state
    }
}

export default searchReducer;